import "magnific-popup";

require('../../partials/project/project-info/big-sum-area');
require('../../partials/project/project-info/gallery-area');
require('../../partials/project/project-info/share-area');
require('../../partials/modal/text-us/text-us')
